module.exports = __webpack_public_path__ + "static/img/img_serve3.caa939bd.png";